import React from 'react';
import { useParams } from 'react-router-dom';
import {
  AssignmentTurnedIn,
  HourglassBottom,
  HowToReg,
} from '@mui/icons-material';
import { ONLINE_TRAINING, ONLINE_TRAINING_ENROLL_LINK } from './lang';
import {
  OVTS_COMPLETION_STATUS,
  useGetOVTSRedirectUrl,
} from '../../../graphql';
import { Alert, Loading } from '../../../../../components';

type MandatoryTrainingProps = {
  onlineTrainingStatus: OVTS_COMPLETION_STATUS;
};

const completedStatusDisplay = (
  <span className="flex gap-2 flex-row items-center text-[#4caf50]">
    <AssignmentTurnedIn />
    {ONLINE_TRAINING.COMPLETED}
  </span>
);

const inCompleteStatusDisplay = (
  <span className="flex gap-2 flex-row items-center text-[#ffb752]">
    <HourglassBottom />
    {ONLINE_TRAINING.NOT_COMPLETED}
  </span>
);

const isNotRequiredDisplay = (
  <span className="flex gap-2 flex-row items-center text-[#336eff]">
    <HowToReg />
    {ONLINE_TRAINING.NOT_REQUIRED}
  </span>
);

export const MandatoryTraining: React.FC<MandatoryTrainingProps> = ({
  onlineTrainingStatus,
}) => {
  const { applicationId = '' } = useParams();
  const { OVTSRedirectUrl, loading, error } =
    useGetOVTSRedirectUrl(applicationId);

  const statusDisplay: Record<OVTS_COMPLETION_STATUS, React.ReactNode> = {
    [OVTS_COMPLETION_STATUS.COMPLETED]: completedStatusDisplay,
    [OVTS_COMPLETION_STATUS.INCOMPLETE]: inCompleteStatusDisplay,
    [OVTS_COMPLETION_STATUS.EXEMPTED]: isNotRequiredDisplay,
    [OVTS_COMPLETION_STATUS.NOT_CREATED]: inCompleteStatusDisplay,
  };

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return loading ? (
    <Loading />
  ) : (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-2 items-center text-lg font-bold">
        <span>{ONLINE_TRAINING.STATUS}</span>
        {statusDisplay[onlineTrainingStatus]}
      </div>
      <div>{ONLINE_TRAINING.REQUIRED_COMPLETE}</div>
      <ul className="list-disc pl-6 font-bold flex flex-col gap-2">
        {ONLINE_TRAINING.MODULES.map((module, index) => (
          <li key={index}>{module}</li>
        ))}
      </ul>

      <div
        dangerouslySetInnerHTML={{
          __html: ONLINE_TRAINING_ENROLL_LINK(OVTSRedirectUrl),
        }}
        className="underline"
      />

      <ul className="list-disc pl-6 flex flex-col gap-2">
        {ONLINE_TRAINING.ENROLL_STEPS.map((step, index) => (
          <li key={index}>
            <div
              dangerouslySetInnerHTML={{
                __html: step,
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
